// seconds * minutes * hours * days
export const COOKIE_EXPIRATION_TIME = 60 * 60 * 24; // 1 day
export const TOKEN_COOKIE = 'komagebi.token';
export const REFRESH_TOKEN_COOKIE = 'komagebi.refreshToken';

export const LONG_DATE_FORMAT = 'DD/MM/YYYY, hh:mm';
